<template>
  <ul v-if="totalPages > 1" class="pages">
    <li class="pages__items">
      <a
        :title="$t('common.paging.first')"
        href="#"
        :class="{ 'btn-disabled': !canViewPreviousPage }"
        class="pages__links"
        @click.prevent="previousPage(1)"
        ><i class="icon-left-chevron-2"></i
      ></a>
    </li>
    <li class="pages__items">
      <a
        :title="$t('common.paging.previous')"
        href="#"
        :class="{ 'btn-disabled': !canViewPreviousPage }"
        class="pages__links"
        @click.prevent="previousPage(currentPageNumber - 1)"
        ><i class="icon-left-chevron"></i
      ></a>
    </li>
    <li class="pages__items">
      {{ $t('common.page') }} {{ currentPageNumber }} {{ $t('common.of').toLowerCase() }}
      {{ totalPages }}
    </li>
    <li class="pages__items">
      <a
        :title="$t('common.paging.next')"
        href="#"
        :class="{ 'btn-disabled': !canViewNextPage }"
        class="pages__links"
        @click.prevent="nextPage(currentPageNumber + 1)"
        ><i class="icon-right-chevron"></i
      ></a>
    </li>
    <li class="pages__items">
      <a
        :title="$t('common.paging.last')"
        href="#"
        :class="{ 'btn-disabled': !canViewNextPage }"
        class="pages__links"
        @click.prevent="nextPage(totalPages)"
        ><i class="icon-right-chevron-2"></i
      ></a>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'BasePagination',

  props: {
    currentPage: {
      type: [Number, String],
      default: 1,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    totalItems: {
      type: Number,
      default: 1,
    },
    pageSize: {
      type: Number,
      default: 1,
    },
  },

  computed: {
    currentPageNumber() {
      return +this.currentPage;
    },

    totalPages() {
      return Math.ceil(this.totalItems / this.pageSize);
    },

    canViewPreviousPage() {
      return this.currentPageNumber > 1;
    },

    canViewNextPage() {
      return this.currentPageNumber < this.totalPages;
    },
  },

  methods: {
    updatePage(page) {
      if (this.disabled) {
        return;
      }
      this.$emit('update:page', page);
    },

    previousPage(page) {
      if (!this.canViewPreviousPage) {
        return;
      }
      this.updatePage(page);
    },

    nextPage(page) {
      if (!this.canViewNextPage) {
        return;
      }
      this.updatePage(page);
    },
  },
};
</script>

<style scoped>
.pages {
  float: unset;
  text-align: right;
}
</style>
